/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import c10Back from "./Screens/C10.png";
import c100Back from "./Screens/C100.png";
//import welcomeScreen from "./Screens/welcome-screen.png";
import paymentStart from "./Screens/payment_start.png";
import enterPINScreen from "./Screens/payment_enterpin.png";
import confirmPINScreen from "./Screens/payment_confirmpin.png";
import processingCard from "./Screens/processing_card.png";
import loadingAnimation from "./Screens/animation.gif";
import swishSwipeToPay from "./Screens/swish-swipetopay.png";
import swishQRScan from "./Screens/swish-qr-scan.png";
import vippsSwipeToPay from "./Screens/vipps-swipetopay.png";
import vippsQRScan from "./Screens/vipps-qr-scan.png";
import klarnaSwipeToPay from "./Screens/klarna-swipetopay.png";
import klarnaQRScan from "./Screens/klarna-qr-scan.png";
import apmApprovedScreen from "./Screens/apm-approved.png";
import paymentApproved from "./Screens/payment_approved.png";
import paymentDeclined from "./Screens/payment_declined.png";
import paymentAborted from "./Screens/payment_aborted.png";
import apmFailedScreen from "./Screens/apm-failed.png";
import placeholder from "./Screens/connected-back.png";
import connectionLostScreen from "./Screens/connection-lost.png";
import unlinkScreen from "./Screens/unlink-screen--paring.png";
import unlinkNotPairedScreen from "./Screens/unlink-screen--notpaired.png";

import ConnectedBack from "./Screens/connected-back.png";
import NotConnectedBack from "./Screens/notconnected-back.png";

import successIcon from "./Screens/success-icon.svg"
import infoIcon from "./Screens/info-icon.svg"
import declinedIcon from "./Screens/declined-icon.svg"

import { paymentProcessConfig } from "./Configs/Config";
import { SetCurrentTransaction, SetTransaction, UnsetTransaction } from "../../../Redux/Features/Simulation/SimulationServicesSlice";
import { useDispatch, useSelector } from "react-redux";
import { SimulationTypeCancel, SimulationTypeLinkTerminal, SimulationTypePurchase, SimulationTypeRefund, SimulationTypeReversal, SimulationTypeUnLinkTerminal } from "../Constants";
import { toast } from "react-toastify";
import { DEFAULT_TERMINAL } from "../../../Configs";

const WelcomeScreen = ({ connected }) => {
    var title = "";
    var description = ""
    var backImage = ConnectedBack
    if (connected) {
        title = "Welcome"
        description = "Waiting for Transaction"
        backImage = ConnectedBack
    } else {
        title = "Welcome"
        description = "Waiting for Transaction"
        backImage = NotConnectedBack
    }
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={backImage} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div className="screen-message-content">
                    <span className="title">{title}</span>
                    <span className="desc">{description}</span>
                </div>
            </div>
        </>
    );
}

const TapToPay = ({ amount, currencyCode }) => {

    const creditCardBack = './assets/images/credit-card-back.svg'; // Replace with your image URL
    const chipBack = './assets/images/chip.svg'; // Replace with your image URL

    const creditCardStyles = {
        backgroundImage: `url(${creditCardBack})`
    };

    const chipStyles = {
        backgroundImage: `url(${chipBack})`
    };

    return (
        <>
            <div id="credit-card" className="creditcard" style={creditCardStyles}>
                <div className="chip" style={chipStyles}></div>
                <div className="cardnumber align-middle">410651******9192</div>
                <div><img className="cardlogo" src="/assets/images/visa.png" /></div>
            </div>
            <div className="screen">
                <div className="screen-slider">
                    <img className="terminalscreen" src={paymentStart} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                </div>
                <div id="amount-taptopay" className="inputs--amount d-flex flex-row justify-content-center mt-2">
                    <span>{amount}&nbsp;{currencyCode}</span>
                </div>
            </div>
        </>
    );
}

const EnterPINScreen = ({ amount, currencyCode }) => {
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={enterPINScreen} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div id="amount-taptopay" className="inputs--amount d-flex flex-row justify-content-center mt-2">
                    <span>{amount}&nbsp;{currencyCode}</span>
                </div>
                <div id="otp" className="inputs--pin d-flex flex-row justify-content-center mt-2">
                    <input className="m-1 text-center" type="text" id="first" maxlength="1" disabled />
                    <input className="m-1 text-center" type="text" id="second" maxlength="1" disabled />
                    <input className="m-1 text-center" type="text" id="third" maxlength="1" disabled />
                    <input className="m-1 text-center" type="text" id="fourth" maxlength="1" disabled />
                </div>
            </div>
        </>
    );
}

const ConfirmPINScreen = ({ pinValue, amount, currencyCode }) => {
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={confirmPINScreen} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div id="amount-taptopay" className="inputs--amount d-flex flex-row justify-content-center mt-2">
                    <span>{amount}&nbsp;{currencyCode}</span>
                </div>
                <div id="otp" className="inputs--pin d-flex flex-row justify-content-center mt-2">
                    <input className="m-1 text-center" type="text" id="first" maxlength="1" value={pinValue.slice(0, 1)} disabled />
                    <input className="m-1 text-center" type="text" id="second" maxlength="1" value={pinValue.slice(1, 2)} disabled />
                    <input className="m-1 text-center" type="text" id="third" maxlength="1" value={pinValue.slice(2, 3)} disabled />
                    <input className="m-1 text-center" type="text" id="fourth" maxlength="1" value={pinValue.slice(3, 4)} disabled />
                </div>
            </div>
        </>
    );
}

const ProcessingScreen = ({ amount, currencyCode }) => {
    return (
        <>
            <div className="screen screen--processing">
                <img className="terminalscreen" src={processingCard} alt='close' layout="fill" objectFit="fill"></img>
                <div id="amount-taptopay" className="inputs--amount d-flex flex-row justify-content-center mt-2">
                    <span>{amount}&nbsp;{currencyCode}</span>
                </div>
                <img className="loading" src={loadingAnimation} placeholder={placeholder} alt='close' layout="fill" objectFit="fill" style={{ width: "219px", height: "25px", marginLeft:"135px" }}></img>
            </div>
        </>
    );
}

const ApprovedScreen = ({ txnType }) => {
    const [txnTypeText, setTxnTypeTxt] = useState("")
    useEffect(() => {
        if (txnType != null) {
            switch (txnType) {
                case 1:
                    setTxnTypeTxt("PURCHASE")
                    break;
                case 2:
                    setTxnTypeTxt("REFUND")
                    break;
                case 4:
                    setTxnTypeTxt("REVERSAL")
                    break;
                default:
                    break;
            }
        }
    }, [txnType])


    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={paymentApproved} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div id="transaction-type--approved" className="transaction-type d-flex flex-row justify-content-center mt-3">
                    <span>{txnTypeText}</span>
                </div>
            </div>
        </>
    );
}

const DeclinedScreen = ({ txnType }) => {
    const [txnTypeText, setTxnTypeTxt] = useState("")
    useEffect(() => {
        if (txnType != null) {
            switch (txnType) {
                case 1:
                    setTxnTypeTxt("PURCHASE")
                    break;
                case 2:
                    setTxnTypeTxt("REFUND")
                    break;
                case 4:
                    setTxnTypeTxt("REVERSAL")
                    break;
                default:
                    break;
            }
        }
    }, [txnType])
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={paymentDeclined} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div id="transaction-type--declined" className="transaction-type inputs--amount d-flex flex-row justify-content-center mt-2">
                    <span>{txnTypeText}</span>
                </div>
            </div>
        </>
    );
}

const AbortedScreen = ({ txnType }) => {
    const [txnTypeText, setTxnTypeTxt] = useState("")
    useEffect(() => {
        if (txnType != null) {
            switch (txnType) {
                case 1:
                    setTxnTypeTxt("PURCHASE")
                    break;
                case 2:
                    setTxnTypeTxt("REFUND")
                    break;
                case 4:
                    setTxnTypeTxt("REVERSAL")
                    break;
                default:
                    break;
            }
        }
    }, [txnType])
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={paymentAborted} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div id="transaction-type--abort" className="transaction-type inputs--amount d-flex flex-row justify-content-center mt-2">
                    <span>{txnTypeText}</span>
                </div>
            </div>
        </>
    );
}

const ApmPay = ({ amount, currencyCode, paymentMethod }) => {
    console.log("ApmPay", paymentMethod)
    var screenImage = swishSwipeToPay
    switch (paymentMethod) {
        case "Swish":
            screenImage = swishSwipeToPay
            break;
        case "Vipps":
            screenImage = vippsSwipeToPay
            break;
        case "Klarna":
            screenImage = klarnaSwipeToPay
            break;
        default:
            screenImage = swishSwipeToPay
            break;
    }
    return (
        <>
            <div className="screen">
                <div className="screen-slider">
                    <img className="terminalscreen" src={screenImage} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                    <div id="amount-taptopay" className="inputs--amount d-flex flex-row justify-content-center mt-2">
                        <span>{amount}&nbsp;{currencyCode}</span>
                    </div>
                </div>
            </div>
        </>
    );
}

const ApmQRScan = ({ amount, currencyCode, paymentMethod }) => {
    var screenImage = swishQRScan
    var amountInlineStyles = null;
    var amountText = amount + " " + currencyCode
    switch (paymentMethod) {
        case "Swish":
            screenImage = swishQRScan
            amountInlineStyles = {
                fontSize: '40px',
                top: '200px',
                color:'#FFF',
                position: 'absolute',
                width: '100%'
            }
            break;
        case "Vipps":
            screenImage = vippsQRScan
            amountInlineStyles = {
                fontSize: '24px',
                top: '200px',
                color:'#fc5b22',
                position: 'absolute',
                fontWeight: 'bold',
                width: '100%'
            }
            amountText = "To pay "+ amountText
            break;
        case "Klarna":
            screenImage = klarnaQRScan
            amountInlineStyles = {
                fontSize: '24px',
                top: '420px',                
                color:'#000',
                position: 'absolute',
                fontWeight: 'bold',
                width: '100%'
            }
            amountText = "Total: "+ amountText
            break;
        default:
            screenImage = swishQRScan
            break;
    }
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={screenImage} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div id="amount-taptopay" style={amountInlineStyles && amountInlineStyles} className="d-flex flex-row justify-content-center mt-2">
                    <span>{amountText}</span>
                </div>
            </div>
        </>
    );
}

const ApmApprovedScreen = () => {
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={apmApprovedScreen} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
            </div>
        </>
    );
}

const ApmFailedScreen = () => {
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={apmFailedScreen} placeholder={placeholder} alt='close' layout="fill" objectFit="fill" />
            </div>
        </>
    );
}

const ConnectionLostScreen = () => {
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={connectionLostScreen} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
            </div>
        </>
    );
}

const UnlinkScreen = ({ registraionCode, connected }) => {
    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={connected ? unlinkNotPairedScreen : unlinkScreen} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div id="otp" className="inputs--unlink d-flex flex-row justify-content-center mt-2">
                    <input className="m-1 text-center rounded" type="text" id="first" maxlength="1" value={registraionCode.slice(0, 1)} disabled />
                    <input className="m-1 text-center rounded" type="text" id="second" maxlength="1" value={registraionCode.slice(1, 2)} disabled />
                    <input className="m-1 text-center rounded" type="text" id="third" maxlength="1" value={registraionCode.slice(2, 3)} disabled />
                    <input className="m-1 text-center rounded" type="text" id="fourth" maxlength="1" value={registraionCode.slice(3, 4)} disabled />
                    <input className="m-1 text-center rounded" type="text" id="fifth" maxlength="1" value={registraionCode.slice(4, 5)} disabled />
                    <input className="m-1 text-center rounded" type="text" id="sixth" maxlength="1" value={registraionCode.slice(5, 6)} disabled />
                </div>
            </div>
        </>
    );
}

const OnlineAPIResultScreen = ({ resultType }) => {
    var title = "";
    var description = ""
    var icon = successIcon;
    switch (resultType) {
        case "approved":
            title = "Approved"
            description = "Transaction was approved"
            icon = successIcon
            break;
        case "cancelled":
            title = "Cancelled"
            description = "Transaction was cancelled"
            icon = infoIcon
            break;
        case "declined":
            title = "Declined"
            description = "Transaction was declined"
            icon = declinedIcon
            break;
        default:
            break;
    }

    return (
        <>
            <div className="screen">
                <img className="terminalscreen" src={ConnectedBack} placeholder={placeholder} alt='close' layout="fill" objectFit="fill"></img>
                <div className="screen-message-content">
                    <span className="title">{title}</span>
                    <span className="desc">{description}</span>
                    <img className="icon" src={icon}></img>
                </div>
            </div>
        </>
    );
}


const Process = ({
    newTransaction,
    model,
    notifySimulatorBackend,
    linkedTerminal,
    setTerminalLinked,
    connected,
    setConnected,
    terminalId,
    setTerminalId
}) => {
    const [currentScreen, setCurrentScreen] = useState({});
    const [eventPayload, setEventPayload] = useState(null)

    const [currentRegistrationCode, setCurrentRegistrationCode] = useState()

    const [simulationValidation, setSimulationValidation] = useState(false);

    // useDispatch() hook is equivalent of mapDispatchToProps.
    const dispatch = useDispatch();

    const simulation = useSelector((state) => state.simulation);



    // This is related to the image loading performance 
    //Please images path which used in this process for the pre-load.
    useEffect(() => {
        const imageUrls = [
            './Screens/C10.png', './Screens/C100.png', './Screens/welcome-screen.png', './Screens/payment_start.png', './Screens/payment_enterpin.png',
            './Screens/payment_confirmpin.png', './Screens/processing_card.png', './Screens/animation.gif', './Screens/swish-swipetopay.png', './Screens/swish-qr-scan.png',
            './Screens/apm-approved.png', './Screens/payment_approved.png', './Screens/payment_declined.png', './Screens/apm-failed.png', './Screens/payment_aborted.png',
            './Screens/unlink-screen.png', './Screens/connection-lost.png'];

        // Preload images
        imageUrls.forEach((imageUrl) => {
            const img = new Image();
            img.src = imageUrl;
        });
    }, []);


    //Once a transaction is received terminal will be generate list of controls and next sequence process.
    //sequence of process is depends on config
    useEffect(() => {
        console.log("newTransaction", newTransaction)
        if (newTransaction != null) {
            switch (newTransaction.type) {
                case SimulationTypePurchase: {
                    console.log("SimulationTypePurchase")
                    var config = paymentProcessConfig["purchase-welcome-screen"]
                    clickControl(config?.start)
                    break;
                }
                case SimulationTypeRefund: {
                    var config = paymentProcessConfig["refund-welcome-screen"]
                    clickControl(config?.start)
                    break;
                }
                case SimulationTypeCancel: {
                    processCancelCurrentTransaction();
                    break;
                }
                case SimulationTypeReversal: {
                    var config = paymentProcessConfig["reversal-welcome-screen"]
                    clickControl(config?.start)
                    break;
                }
                case SimulationTypeLinkTerminal: {
                    processLinkTerminal(newTransaction)
                    break;
                }
                case SimulationTypeUnLinkTerminal: {
                    processUnlinkTerminal(newTransaction);
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }, [newTransaction])

    useEffect(() => {
        //handle based on the timeOut configuration.
        if (currentScreen != null && currentScreen.timeOut != null && currentScreen.timeOut != undefined) {
            setTimeout(() => {
                var screen = paymentProcessConfig[currentScreen.timeOut?.nextScreen]
                setCurrentScreen(screen);
            }, currentScreen.timeOut?.interval);
        }
    }, [currentScreen?.timeOut])

    useEffect(() => {
        // handle end transaction processing
        if (currentScreen != null) {
            if (currentScreen?.endProcess != undefined && currentScreen?.endProcess == true) {
                dispatch(UnsetTransaction())
            }
        }
    }, [currentScreen])

    useEffect(() => {
        if (linkedTerminal) {
            setCurrentScreen(paymentProcessConfig["welcome-screen"])
        } else {
            const randomNumber = Math.floor(Math.random() * 900000) + 100000;
            setCurrentRegistrationCode(randomNumber.toString())
            setCurrentScreen(paymentProcessConfig["unlink-terminal"])
        }
    }, [linkedTerminal])

    const processCancelCurrentTransaction = () => {
        if (simulation.CurrentTransaction != null) {
            // cancel current trasanction
            // should cancel original transaction and update database with txn status
            var resultTypeOfOriginalTransaction = {
                "category": 2,
                "value": 7 // chashier cancel transaction.
            }
            notifySimulatorBackend(resultTypeOfOriginalTransaction);
            
            //complete canceled transaction.
            var validationType = {
                "category": 1,
                "value": 1 // cancel approved
            }
            notifySimulatorBackend(validationType);
            setCurrentScreen(paymentProcessConfig["aborted"])
        }
    }

    const processLinkTerminal = (newTransaction) => {
        if (newTransaction.requestBody?.registrationCode == currentRegistrationCode) {
            if (!linkedTerminal) {
                setTerminalLinked(true);
                setTerminalId(newTransaction.requestBody?.terminalId)
                setConnected(true)
                var validationType = {
                    "category": 3,  //unlink and link terminal type
                    "value": 1 // terminal linking success
                }
                notifySimulatorBackend(validationType);
            }
        } else {
            toast.error("Registration code mismatch");
            // TODO: set validation code here. also do the backend changes
            var validationType = {
                "category": 1,
                "value": 104 // terminal not found for registration code.
            }
            notifySimulatorBackend(validationType);
        }
    }

    const processUnlinkTerminal = (newTransaction) => {
        if (linkedTerminal) {
            if (newTransaction?.requestBody?.terminalId !== terminalId) {
                var validationType = {
                    "category": 1,  //validation type
                    "value": 13
                };
                notifySimulatorBackend(validationType);
            } else {
                setTerminalLinked(false);
                setTerminalId(''); // Clear the terminalId after unlinking
                //if terminal unlink success you should notify backend with below payload.
                var validationType = {
                    "category": 3,  //unlink and link terminal type
                    "value": 1 // terminal linking success
                };
                notifySimulatorBackend(validationType);
            }
        }
    };
    

    const simulatePurchaseStart = (action) => {
        var screen = null;
        if (newTransaction?.requestBody?.paymentMethod == "Swish" || newTransaction?.requestBody?.paymentMethod == "Klarna" || newTransaction?.requestBody?.paymentMethod == "Vipps") {
            screen = paymentProcessConfig["apm-qrscan"]
        } else {
            screen = paymentProcessConfig[action.nextScreen]
        }
        setCurrentScreen(screen);
    }

    const simulateRefundStart = (action) => {
        var screen = null;
        if (newTransaction?.requestBody?.paymentMethod == "Swish" || newTransaction?.requestBody?.paymentMethod == "Klarna" || newTransaction?.requestBody?.paymentMethod == "Vipps") {
            screen = paymentProcessConfig["apm-qrscan"]
        } else {
            screen = paymentProcessConfig[action.nextScreen]
        }
        setCurrentScreen(screen);
    }

    const simulateReversalStart = (action) => {
        var screen = paymentProcessConfig[action.nextScreen]
        setCurrentScreen(screen);
    }

    const simulateCardTap = (action) => {
        var credit_card_ele = document.getElementById("credit-card");
        credit_card_ele.classList.add("move");
        setTimeout(() => {
            var screen = paymentProcessConfig[action.nextScreen]
            setCurrentScreen(screen);
        }, 2000)
    }

    const simulateEnterPIN = (action) => {
        var screen = paymentProcessConfig[action.nextScreen]
        setCurrentScreen(screen);
    }

    const simulateConnectionLost = (action) => {
        setConnected(false);
        var screen = paymentProcessConfig[action.nextScreen]
        setCurrentScreen(screen);
    }

    const simulateAutoReconnect = (action) => {
        setConnected(true);
        var screen = paymentProcessConfig[action.nextScreen]
        setCurrentScreen(screen);
    }

    const simulateApmPay = (action) => {
        var screen = paymentProcessConfig[action.nextScreen]
        setCurrentScreen(screen);
    }

    const executeCurrentAction = (action) => {
        var method = action?.method;
        if (method?.payload != null) {
            setEventPayload(method?.payload)
        }
        console.log("method?.name", method?.name)
        switch (method?.name) {
            case "purchase-start": {
                //you should mannually handle next screen here.
                simulatePurchaseStart(action)
                break;
            }
            case "refund-start": {
                //you should mannually handle next screen here.
                simulateRefundStart(action)
                break;
            }
            case "reversal-start": {
                //you should mannually handle next screen here.
                simulateReversalStart(action)
                break;
            }
            case "func-card-tap": {
                //you should mannually handle next screen here.
                simulateCardTap(action)
                break;
            }
            case "func-confirm-pin": {
                //you should mannually handle next screen here.
                simulateEnterPIN(action);
                break;
            }
            case "func-connection-lost": {
                //you should mannually handle next screen here.
                simulateConnectionLost(action);
                break;
            }
            case "func-auto-reconnect": {
                //you should mannually handle next screen here.
                simulateAutoReconnect(action);
                break;
            }
            default:
                break;
        }
    }

    const clickControl = (control) => {
        //notify simulator
        let type = control.type;
        if (type != undefined) {
            notifySimulatorBackend(type);
            //CHANGE LOGIC DEPENDENCY clickControl FUNC
            if (type.category == 1 && type.value == 1) {
                //If user start the transaction processing after validation.
                //Then recevied transaction as current transaction. Now terminal is busy with this transaction.
                //update current transaction with new property as in-progress as true.
                dispatch(SetTransaction(newTransaction))
            }
        }

        //proceed next actions.
        let action = control.action
        if (action.method != null) {
            executeCurrentAction(action)
            // any action you need to trigger when select control button.
        }
        else if (action.nextScreen != null) {
            var screen = paymentProcessConfig[action.nextScreen]
            setCurrentScreen(screen);
        }
    }

    const returnCurrencySymbolByCode = (currencyCode) => {
        console.log("Currency Code:", currencyCode);
        var symbol = "SEK"
        switch (currencyCode) {
            case 752: {
                symbol = "SEK"
                break;
            }
            case 578: {
                symbol = "NOK"
                break;
            } 
            case 840: {
                symbol = "USD"
                break;
            }
            case 978: {
                symbol = "EUR"
                break;
            }
            case 826: {
                symbol = "GBP"
                break;
            }
            case 392: {
                symbol = "JPY"
                break;
            }
            case 208: {
                symbol = "DKK"
                break;
            }
            default:
                symbol = "SEK"
                break;
        }
        return symbol;
    }

    const renderTerminalView = (screen) => {
        switch (screen?.name) {
            case "welcome-screen":
            case "purchase-welcome-screen":
            case "refund-welcome-screen":
            case "reversal-welcome-screen":
            case "disconnect-screen":
            case "reversal-processing":
                {
                    return <WelcomeScreen connected={connected}></WelcomeScreen>;
                }
            case "tap-to-pay":
                {
                    return <TapToPay amount={newTransaction?.requestBody?.amount} currencyCode={returnCurrencySymbolByCode(newTransaction?.requestBody?.currencyCode)}></TapToPay>;
                }
            case "enter-pin":
                {
                    return <EnterPINScreen amount={newTransaction?.requestBody?.amount} currencyCode={returnCurrencySymbolByCode(newTransaction?.requestBody?.currencyCode)}></EnterPINScreen>;
                }
            case "confirm-pin":
                {
                    return <ConfirmPINScreen pinValue={eventPayload?.value} amount={newTransaction?.requestBody?.amount} currencyCode={returnCurrencySymbolByCode(newTransaction?.requestBody?.currencyCode)}></ConfirmPINScreen>;
                }
            case "processing":
            case "cancel-processing":
                {
                    return <ProcessingScreen amount={newTransaction?.requestBody?.amount} currencyCode={returnCurrencySymbolByCode(newTransaction?.requestBody?.currencyCode)}></ProcessingScreen>;
                }
            case "approved":
            case "reversal-approved":
                {
                    return <ApprovedScreen txnType={simulation.CurrentTransaction?.type}></ApprovedScreen>;
                }
            case "declined":
                {
                    return <DeclinedScreen txnType={simulation.CurrentTransaction?.type}></DeclinedScreen>;
                }
            case "aborted":
                {
                    return <AbortedScreen txnType={simulation.CurrentTransaction?.type}></AbortedScreen>;
                }
            case "online-api-approved":
                {
                    return <OnlineAPIResultScreen resultType="approved"></OnlineAPIResultScreen>;
                }
            case "online-api-cancelled":
                {
                    return <OnlineAPIResultScreen resultType="cancelled"></OnlineAPIResultScreen>;
                }
            case "online-api-declined":
                {
                    return <OnlineAPIResultScreen resultType="declined"></OnlineAPIResultScreen>;
                }
            case "apm-pay":
                {
                    return <ApmPay amount={newTransaction?.requestBody?.amount} currencyCode={returnCurrencySymbolByCode(newTransaction?.requestBody?.currencyCode)} paymentMethod={newTransaction?.requestBody?.paymentMethod}></ApmPay>;
                }
            case "apm-qrscan":
                {
                    return <ApmQRScan amount={newTransaction?.requestBody?.amount} currencyCode={returnCurrencySymbolByCode(newTransaction?.requestBody?.currencyCode)} paymentMethod={newTransaction?.requestBody?.paymentMethod}></ApmQRScan>;
                }
            case "apm-approve":
                {
                    return <ApmApprovedScreen></ApmApprovedScreen>;
                }
            case "apm-failed":
                {
                    return <ApmFailedScreen></ApmFailedScreen>;
                }
            case "connection-lost":
                {
                    return <ConnectionLostScreen></ConnectionLostScreen>;
                }
            case "unlink-terminal":
                {
                    return <UnlinkScreen registraionCode={currentRegistrationCode} connected={connected}></UnlinkScreen>;
                }
            default:
                return <h1>No screen attached</h1>
        }
    }

    const attachBackImageSrcByModel = (model) => {
        var result = c100Back
        if (model === "C10") {
            result = c10Back
        }
        return result
    }

    // const simulationCustomValidation = (e) => {
    //     let newState = e.target.checked
    //     // Check if the new value is different from the current value
    //     if (simulationValidation !== newState) {
    //         // Update the state only if the new value is different
    //         setSimulationValidation(newState)
    //     }
    // }

    return (
        <>
            <div className="terminal-view">
                <img className="terminalback" src={attachBackImageSrcByModel(model)} alt='close' layout="fill" objectFit="fill"></img>
                {renderTerminalView(currentScreen)}
            </div>
            <div className="control-view">
                <div className="control-view--header">
                    <div id="basic-terminal-configuration" className="configuration-panel">
                    <div className="input-group mb-3">
    <span className="input-group-text" id="basic-addon1">Terminal Id</span>
    <input 
        type="text" 
        className="form-control" 
        placeholder="Example: 80001816" 
        aria-label="Terminal Id" 
        aria-describedby="basic-addon1" 
        value={terminalId} 
        onChange={(e) => setTerminalId(e.target.value)} 
        disabled={linkedTerminal} 
    />
</div>
                    </div>
                    {/* <div id="skip-prevalidation" className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchValidation" onClick={(e) => { simulationCustomValidation(e) }} checked={simulationValidation} disabled={simulation.CurrentTransaction != null ? true : false} />
                        <label className="form-check-label" for="flexSwitchValidation">Simulate Pre Request Validation</label>
                    </div> */}
                </div>
                <div id="control-actions" className="control-view--content">
                    <ul className="control-view--comments">
                        {currentScreen.comments && currentScreen.comments.map((com, index) => (
                            <li>{com}</li>
                        ))}
                    </ul>
                    {currentScreen.controls?.length > 0 ? currentScreen.controls.map(control => {
                        return (
                            <div className="control-view--controller">
                                <a target="_blank" rel="noreferrer" onClick={() => { clickControl(control) }}
                                    className={control.style} role="button">{control.title}</a>
                            </div>
                        )
                    }) :
                        <ul>
                            <li>Use connection id and make the connection between westpay simulator and your client. Please provide connectionId as a header attribute</li>
                            <li>All request validation failures are not captured by simulator, but system generate 400 validation response for your client based on the request payload.</li>
                            <li>You can manually do the linking/unlinking terminal and network connectivity using above toggle buttons.</li>
                            <li>You can use control button here for the manual simulation of the payment process.</li>
                        </ul>}
                </div>
                <div className="control-view--footer">
                    {currentScreen?.start && <a target="_blank" rel="noreferrer" onClick={() => { clickControl(currentScreen?.start) }}
                        className={currentScreen?.start.style} role="button">{currentScreen?.start.title}</a>
                    }
                </div>
            </div>
        </>
    );
};


export default Process;